import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

// ============================================
// IMPORT YOUR FACILITY IMAGES HERE ⬇️
// ============================================
import workshop1 from '../assets/images/workshop1.jpg';
import workshop2 from '../assets/images/workshop2.jpg';
import workshop3 from '../assets/images/workshop3.jpg';
import workshop4 from '../assets/images/workshop4.jpg';
import workshop5 from '../assets/images/workshop5.jpg';
import workshop6 from '../assets/images/workshop6.jpg';

import pipeRoof from '../assets/images/piperoof.jpg';

import machinery1 from '../assets/images/machinery1.jpg';
import machinery2 from '../assets/images/machinery2.jpg';
import machinery3 from '../assets/images/machinery3.jpg';
import machinery4 from '../assets/images/machinery4.jpg';
import machinery5 from '../assets/images/machinery5.jpg';
import machinery6 from '../assets/images/machinery6.jpg';
import machinery7 from '../assets/images/machinery7.jpg';
import machinery8 from '../assets/images/machinery8.jpg';
import machinery9 from '../assets/images/machinery9.jpg';

import '../styles/Pages.css';

const Facilities = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Images array for Workshop (6 images)
  const workshopImages = [workshop1, workshop2, workshop3, workshop4, workshop5, workshop6];

  // Images array for Machinery (9 images)
  const machineryImages = [machinery1, machinery2, machinery3, machinery4, machinery5, machinery6, machinery7, machinery8, machinery9];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Our Facilities</h1>
            <p>State-of-the-Art Infrastructure & Equipment</p>
          </div>
        </div>
      </section>

      {/* SECTION 1: CENTRAL WORKSHOP - TEXT LEFT + IMAGES RIGHT (3x2) */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'start' }}>
          
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '20px' }}>
              CENTRAL WORKSHOP
            </h2>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              Central Workshop established by us is the key strength for all our projects which caters to the needs of our total plant and machinery, fabrication works, gantry works. Central Workshop is our in-house competence and it is well equipped with machinery and highly skilled technicians. This workshop is centrally located at Hyderabad, Telangana, India.
            </p>
          </div>

          {/* IMAGES GRID - 3 COLUMNS, 2 ROWS */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {workshopImages.map((img, index) => (
              <div key={index} style={{ 
                overflow: 'hidden', 
                borderRadius: '8px', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                aspectRatio: '1'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }}>
                <img 
                  src={img} 
                  alt={`Workshop ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.3s ease' }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 2: PIPE ROOFING - IMAGE LEFT + TEXT RIGHT */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'center' }}>
          
          {/* IMAGE */}
          <div style={{ 
            overflow: 'hidden', 
            borderRadius: '8px', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            aspectRatio: '4/3'
          }}>
            <img 
              src={pipeRoof} 
              alt="Pipe Roofing"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>

          {/* TEXT */}
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '20px' }}>
              Pipe Roofing Manufacturing Unit
            </h2>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              With our internal expertise and technology, Max Infra has achieved another milestone in their growth path by establishing its own Pile Roofing Manufacturing Unit to cater to our project needs.
            </p>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', textAlign: 'justify' }}>
              Piple Roofing Manufacturing Unit facility plays a key role for our projects and it ensure supply on demand basis without depending on external resources / vendors.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3: FLEET OF PLANT & MACHINERY - TEXT LEFT + IMAGES RIGHT (3x3) */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: '50px', alignItems: 'start' }}>
          
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '20px' }}>
              FLEET OF PLANT & MACHINERY
            </h2>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              We operate a large fleet of multi brand, manifold Plant and Machinery of different sizes and capacities. We equip all our projects with brand new machinery to ensure maximum productivity with minimum down time for maintenance.
            </p>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', textAlign: 'justify' }}>
              This is another capability of Max Infra which will facilitate us in achieving optimum cycle times, miles stones and overall completion of projects before schedule time.
            </p>
          </div>

          {/* IMAGES GRID - 3 COLUMNS */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {machineryImages.map((img, index) => (
              <div key={index} style={{ 
                overflow: 'hidden', 
                borderRadius: '8px', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                aspectRatio: '1'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }}>
                <img 
                  src={img} 
                  alt={`Machinery ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.3s ease' }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE */}
      <style>{`
        @media (max-width: 1024px) {
          .facility-section {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          .images-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          .facility-section {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          .images-grid {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Facilities;